import { useEffect, useState } from 'react';

export default function useCopied(defaultValue, resetTime = 1000) {
  const [copied, setCopied] = useState(defaultValue);

  useEffect(() => {
    if (copied) {
      window.setTimeout(() => {
        setCopied(false);
      }, resetTime);
    }
  }, [copied, resetTime]);
  return [copied, setCopied];
}
